import type { Client, RequestContext } from "../client";
import type { RouteArgs } from "../resolver";
import type { NewSubscriptionResource, SubscriptionResource } from "../resources";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";

export type SubscriptionsListArgs = ListArgs &
    RouteArgs & {
        partialName?: string;
    };

export class SubscriptionRepository extends BasicRepository<SubscriptionResource, NewSubscriptionResource, SubscriptionsListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Subscriptions", client, requestContext);
    }
}
